import type { ConversationMessage } from '@/types/clinician';

// Healthie can return timeline notes that contain only formatting or
// zero-width characters. They are conversation events, but not messages a
// clinician can read, and rendering them creates an empty attributed bubble.
const INVISIBLE_MESSAGE_CHARACTERS = /[\u00a0\u200b-\u200f\u2060\ufeff]/g;

export function visibleConversationMessages(
  messages: ConversationMessage[],
): ConversationMessage[] {
  return messages.flatMap((message) => {
    const text = (message.text ?? '')
      .replace(INVISIBLE_MESSAGE_CHARACTERS, '')
      .trim();
    const attachments = message.attachments ?? [];

    if (!text && attachments.length === 0) return [];
    return [{ ...message, text, attachments }];
  });
}
